import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import {
  PropertyDefinitionDto,
  PropertyMarketStatusDto,
  PropertyOfferType,
  PropertySellerRole,
  PropertyType,
} from '@workspace/data-types';
import { EtxeEnumDisplayPipe } from '../../../pipes/etxe-enum-display.pipe';

@Component({
  selector: 'etxe-property-definition-display',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, EtxeEnumDisplayPipe],
  templateUrl: './definition-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class PropertyDefinitionDisplayComponent {
  definition = input.required<PropertyDefinitionDto>();
  marketStatus = input<PropertyMarketStatusDto>();

  PropertySellerRole = PropertySellerRole;
  PropertyOfferType = PropertyOfferType;
  PropertyType = PropertyType;

  seller = computed(() => this.definition()?.seller);
  beneficiary = computed(() => this.seller()?.beneficiary);

  isNonOwner = computed(() => {
    const role = this.seller()?.role;
    return !!role && role !== PropertySellerRole.OWNER;
  });
}
